try {
    window.$ = window.jQuery = require('jquery');

} catch (e) {}
// Admin scripts

require('./admin/index');
require('./uploadFile.js');
require('./swap');
require('./jquery.nestable.js');
require('bootstrap-select-v4');
require('magnific-popup');
require('lightgallery.js');
//require('bootstrap-colorpicker');
window.autosize = require('autosize');
require('./vue');
window.ClassicEditor = require ("@ckeditor/ckeditor5-build-classic");
